import React from 'react';

import ErrorBoundary from '../components/error-boundary';
import { getBreakpoint } from '../media-queries';

export default class ModuleLoader extends React.Component {
    state = {
        postId: 0,
        template: '',
        modules: [],

        _device: 'sm',
        _components: {},
    };

    componentDidMount() {
        const { postId, template } = NEA;
        const modules = this.props.config;
        this.setState({ postId, template, modules });

        // Load page module templates
        modules.forEach((module) => {
            import(`../modules/${module.name}`).then(
                ((name) => ({ default: Component }) => {
                    let components = this.state._components;
                    components[name] = Component;
                    this.setState({ _components: components });
                })(module.name),
            );
        });

        window.addEventListener('resize', () => this.setDevice());
        this.setDevice();
    }

    setDevice() {
        const bp = getBreakpoint();

        let device;
        switch (bp) {
            case 'xsm':
            case 'sm':
                device = 'sm';
                break;
            case 'md':
                device = 'md';
                break;
            case 'lg':
            case 'xlg':
                device = 'lg';
                break;
        }

        this.setState({ _device: device });
    }

    render() {
        const { postId, template, modules, _components, _device } = this.state;
        return (
            <>
                {modules.map(({ name, instance, config, visibility }) => {
                    const visible = visibility.indexOf(_device) > -1;
                    const Component = _components[name];

                    try {
                        return visible && Component ? (
                            <ErrorBoundary key={`${name}-${instance}`}>
                                <Component
                                    postId={postId}
                                    template={template}
                                    name={name}
                                    instance={instance}
                                    config={config}
                                />
                            </ErrorBoundary>
                        ) : null;
                    } catch (err) {
                        console.error(err);
                        return null;
                    }
                })}
            </>
        );
    }
}
